import apiClient from './apiClient';

export const mapApi = {
  queryMapData: async (payload) => {
    const response = await apiClient.post('/mapdata/query', payload);
    return response.data;
  },
  geocode: async (query) => {
    const response = await apiClient.post('/geocoding/geocode', { query });
    return response.data;
  }
};
